import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-library/trigger";
const DOMAIN_EVENT = "/reminder-builder/reminder-setup/domain-event";

// tbl_rem_trigger. Write calls and Preview rows (which reads live rows) are Super Admin only.
const apiReminderTrigger = {
  create:          (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:          (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:          (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById:         (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:          (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
  // Condition builder: operators (with the types they accept) and units, and the context dates.
  getOperators:    ()            => axiosClient.get(`${BASE}/get-operators`),
  getContextKeys:  ()            => axiosClient.get(`${BASE}/get-context-keys`),
  // An unsaved definition (+ id to merge with the saved row) -> { valid, problems } (publish checks).
  validate:        (payload)     => axiosClient.post(`${BASE}/validate`, payload),
  // { id } or an unsaved definition, + param_values, offsets, offset_unit, timezone.
  previewRows:     (payload)     => axiosClient.post(`${BASE}/preview-rows`, payload),
  publish:         (id)          => axiosClient.put(`${BASE}/publish/${id}`),
  archive:         (id)          => axiosClient.put(`${BASE}/archive/${id}`),
  clone:           (id)          => axiosClient.post(`${BASE}/clone/${id}`),
  getUsedBy:       (id)          => axiosClient.get(`${BASE}/used-by/${id}`),
  // Active domain events of one source (the DOMAIN_EVENT picker).
  getEventOptions: (sourceFid)   => axiosClient.get(`${DOMAIN_EVENT}/get-all`, { params: { source_fid: sourceFid } }),
};

export default apiReminderTrigger;
